import React from 'react';

const Loader = () => {

  //TODO replace with à real loader
  return <p>Loading ...</p>
}

export default Loader;